import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import AsyncComponent from '../../AsyncComponent';

import GuestRoute from '../../GuestRoute';

import PrivateRoute from './PrivateRoute';

import Event from '../../../screens/Event';

import Player from '../../../components/Player';

const Home = AsyncComponent(() => import('../../../screens/Home'));
const Profile = AsyncComponent(() => import('../../../screens/Profile'));
const EventsContainer = AsyncComponent(() =>
	import('../../../screens/Events/EventsContainer')
);
const EventsContainerAdmin = AsyncComponent(() =>
	import('../../../screens/Events/admin')
);
const Packages = AsyncComponent(() => import('../../../screens/Packages'));

const NewEventContainer = AsyncComponent(() =>
	import('../../../screens/NewEvent/NewEventContainer')
);
const Help = AsyncComponent(() => import('../../../components/Event/Help'));

const Users = AsyncComponent(() => import('../../../screens/Users'));

const VideoServers = AsyncComponent(() =>
	import('../../../screens/VideoServers')
);
const AdminRecordings = AsyncComponent(() =>
	import('../../../screens/Admin/Recordings')
);
const MyBrand = AsyncComponent(() => import('../../../screens/MyBrand'));
const Helps = AsyncComponent(() => import('../../../screens/Helps'));

const IframePlayer = AsyncComponent(() =>
	import('../../../screens/IframePlayer')
);
const Survey = AsyncComponent(() => import('../../../screens/Survey'));

const Encoder = AsyncComponent(() => import('../../../screens/Encoder'));

const RouterComponent = ({
	process,
	currentUser,
	authenticated,
	onRequestLoading,
	onLogout,
	firebase,
	setUserParams,
	top_loading,
	hasMenu,
	setMenuStatus,
	helpers,
	trackEvent,
}) => {
	let isAdmin = false;
	if (currentUser.sa) {
		isAdmin = currentUser.sa === currentUser.uid;
	}

	const { whiteBrand } = currentUser.packageDetails;

	if (currentUser.isAnonymous) {
		return (
			<Router basename={process.env.PUBLIC_URL}>
				<Switch>
					<GuestRoute
						exact
						path="/feedback/:id"
						authenticated={authenticated}
						currentUser={currentUser}
						onLogout={onLogout}
						noRedirect
						component={Survey}
					/>

					<GuestRoute
						exact
						path="/iframe/:organizer/:event_name"
						authenticated={authenticated}
						setUserParams={setUserParams}
						currentUser={currentUser}
						onLogout={onLogout}
						noRedirect
						component={IframePlayer}
					/>

					<GuestRoute
						exact
						path="/encoder/:organizer/:id"
						authenticated={authenticated}
						setUserParams={setUserParams}
						currentUser={currentUser}
						onLogout={onLogout}
						noRedirect
						component={Encoder}
						firebase={firebase}
					/>
				</Switch>
			</Router>
		);
	}

	return (
		<Router basename={process.env.PUBLIC_URL}>
			<Switch>
				<PrivateRoute
					exact
					path="/profile"
					component={Profile}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					setUserParams={setUserParams}
					currentUser={currentUser}
					onRequestLoading={onRequestLoading}
				/>

				<PrivateRoute
					exact
					path="/player"
					component={Player}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					setUserParams={setUserParams}
					currentUser={currentUser}
					onRequestLoading={onRequestLoading}
				/>

				<PrivateRoute
					exact
					path="/events"
					component={EventsContainer}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					trackEvent={trackEvent}
					currentUser={currentUser}
					onRequestLoading={onRequestLoading}
				/>

				<PrivateRoute
					exact
					path="/events/new-event"
					component={NewEventContainer}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					trackEvent={trackEvent}
					currentUser={currentUser}
					isLoading={top_loading}
					onRequestLoading={onRequestLoading}
				/>

				<PrivateRoute
					exact
					path="/event/:eid/:tab"
					component={Event}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					trackEvent={trackEvent}
					currentUser={currentUser}
					isLoading={top_loading}
					onRequestLoading={onRequestLoading}
				/>

				<PrivateRoute
					exact
					path="/help"
					component={Help}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					isAlone={true}
					currentUser={currentUser}
					isLoading={top_loading}
					onRequestLoading={onRequestLoading}
				/>

				{whiteBrand && (
					<PrivateRoute
						exact
						path="/brand"
						component={MyBrand}
						top_loading={top_loading}
						setMenuStatus={setMenuStatus}
						firebase={firebase}
						onLogout={onLogout}
						hasMenu={hasMenu}
						helpers={helpers}
						authenticated={authenticated}
						folder={`customBrands/${currentUser.uid}`}
						collection={'users'}
						bd={currentUser}
						uid={currentUser.uid}
						setUserParams={setUserParams}
						currentUser={currentUser}
						onRequestLoading={onRequestLoading}
					/>
				)}

				{isAdmin && (
					<PrivateRoute
						exact
						path="/users*"
						component={Users}
						top_loading={top_loading}
						setMenuStatus={setMenuStatus}
						firebase={firebase}
						onLogout={onLogout}
						hasMenu={hasMenu}
						helpers={helpers}
						authenticated={authenticated}
						currentUser={currentUser}
						isLoading={top_loading}
						onRequestLoading={onRequestLoading}
					/>
				)}

				{isAdmin && (
					<PrivateRoute
						exact
						path="/all-events"
						top_loading={top_loading}
						setMenuStatus={setMenuStatus}
						firebase={firebase}
						onLogout={onLogout}
						hasMenu={hasMenu}
						helpers={helpers}
						component={EventsContainerAdmin}
						sa={true}
						trackEvent={trackEvent}
						authenticated={authenticated}
						currentUser={currentUser}
						isLoading={top_loading}
						onRequestLoading={onRequestLoading}
					/>
				)}

				{isAdmin && (
					<PrivateRoute
						exact
						path="/packages*"
						component={Packages}
						top_loading={top_loading}
						setMenuStatus={setMenuStatus}
						firebase={firebase}
						onLogout={onLogout}
						hasMenu={hasMenu}
						helpers={helpers}
						authenticated={authenticated}
						currentUser={currentUser}
						isLoading={top_loading}
						onRequestLoading={onRequestLoading}
					/>
				)}

			{isAdmin && (
				<PrivateRoute
					path="/video-servers"
					component={VideoServers}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					currentUser={currentUser}
					isLoading={top_loading}
					onRequestLoading={onRequestLoading}
				/>
			)}

			{isAdmin && (
				<PrivateRoute
					exact
					path="/admin/recordings"
					component={AdminRecordings}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					currentUser={currentUser}
					isAdmin={isAdmin}
					isLoading={top_loading}
					onRequestLoading={onRequestLoading}
				/>
			)}

			{isAdmin && (
				<PrivateRoute
					exact
					path="/helps"
					component={Helps}
						top_loading={top_loading}
						setMenuStatus={setMenuStatus}
						firebase={firebase}
						onLogout={onLogout}
						hasMenu={hasMenu}
						helpers={helpers}
						authenticated={authenticated}
						currentUser={currentUser}
						isLoading={top_loading}
						onRequestLoading={onRequestLoading}
					/>
				)}

				<GuestRoute
					exact
					path="/feedback/:id"
					authenticated={authenticated}
					currentUser={currentUser}
					onLogout={onLogout}
					noRedirect
					component={Survey}
				/>

				<GuestRoute
					exact
					path="/iframe/:organizer/:event_name"
					authenticated={authenticated}
					setUserParams={setUserParams}
					currentUser={currentUser}
					onLogout={onLogout}
					noRedirect
					component={IframePlayer}
				/>

				<GuestRoute
					exact
					path="/encoder/:organizer/:id"
					authenticated={authenticated}
					setUserParams={setUserParams}
					currentUser={currentUser}
					onLogout={onLogout}
					noRedirect
					component={Encoder}
					firebase={firebase}
				/>

				<PrivateRoute
					component={Home}
					top_loading={top_loading}
					setMenuStatus={setMenuStatus}
					firebase={firebase}
					onLogout={onLogout}
					hasMenu={hasMenu}
					helpers={helpers}
					authenticated={authenticated}
					trackEvent={trackEvent}
					currentUser={currentUser}
					setUserParams={setUserParams}
					onRequestLoading={onRequestLoading}
				/>

				<div onClick={setMenuStatus} className="az-navbar-backdrop"></div>
			</Switch>
		</Router>
	);
};

export default RouterComponent;
